export default class Iso14726Controller {

  constructor() {

    this.ersteGruppe = [{
      artikelId: 19120,
      title: "Waste media",
      open: true,
      menge: 0
    }, {
      artikelId: 19127,
      title: "Fresh water",
      menge: 0
    }, {
      artikelId: 19136,
      title: "Fuel",
      menge: 0
    }, {
      artikelId: 19142,
      title: "Sea water",
      menge: 0
    }];

    this.zweiteGruppe = [{
      artikelId: 19147,
      title: "Non flammable gases",
      open: true,
      menge: 0
    }, {
      artikelId: 19157,
      title: "Acids, alkalis",
      menge: 0
    }, {
      artikelId: 19158,
      title: "Masses (dry and wet)",
      menge: 0
    }, {
      artikelId: 19159,
      title: "Oil other than fuel",
      menge: 0
    }, {
      artikelId: 19190,
      title: "Steam",
      menge: 0
    }];

    this.dritteGruppe = [{
      artikelId: 19173,
      title: "Air in ventilation system",
      open: true,
      menge: 0
    }, {
      artikelId: 19166,
      title: "Firefighting/fire protection",
      menge: 0
    }, {
      artikelId: 19185,
      title: "Flammable gases",
      menge: 0
    }];
  }

  requestQuotation() {
    app.clearCard();

    this.ersteGruppe
      .concat(this.zweiteGruppe)
      .concat(this.dritteGruppe)
      .filter(g => g.artikel)
      .map(g => g.artikel)
      .forEach(a => {
        app.addToCard(a);
        if (a.UnterArtikel) {
          a.UnterArtikel.forEach(a => app.addToCard(a));
        }
      });

    if (app.artikel.length === 0) {
      app.translate('error.keineArtikel').then((message) => {
        window.toastr.error(message, 'Error');
      });
      return;
    }

    app.$location.path('/requestQuote');
  }
}



/** WEBPACK FOOTER **
 ** ./public/app/artikel/Iso14726Controller.js
 **/